/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-new-object */
/* eslint-disable no-tabs */
import '../../../assets/css/pages/honor-list.css';
import '../../../assets/css/pages/product.css';
import api from '../../utils/api';
import {
  Mobile,
} from '../../utils/common';

let hofListObj = new Object();
let hofIndividualObj = new Object();

let genderCheck = '';
let completeCnt = '';
let pageCount = 0;
let totalData; // 총 데이터 수
// eslint-disable-next-line no-unused-vars
let globalCurrentPage = '1'; // 현재 페이지
let timeString;

const modal = document.getElementById('modalWrap');
const closeBtn = document.getElementById('closeBtn');

// 시간 데이터 통일
function timeConvert(value) {
  if (value !== '') {
    let recordTimeSplit = '';
    let hours = '';
    let minutes = '';
    let seconds = '';

    const recordTimeCut = value.substring(0, 8);
    recordTimeSplit = recordTimeCut.split(':');

    if (recordTimeSplit[0].length === 1) {
      hours = `0${recordTimeSplit[0]}`;
    } else {
      hours = recordTimeSplit[0];
    }
    minutes = recordTimeSplit[1];
    seconds = recordTimeSplit[2];

    timeString = `${hours}:${minutes}:${seconds}`;
  } else {
    timeString = '00:00:00';
  }

  return timeString;
}

// 명예의 전당 리스트 출력
function hofIndList() {
  const renderTarget = document.getElementById('hof_list');

  let name = '';
  let fileName = '';
  let recordCnt = '';
  let bestYear = '';
  let bestRecord = '';

  hofListObj.data.hofDetailDtoList.forEach((ele, i) => {
    name = ele.name;

    if (hofListObj.data.hofDetailDtoList[i].fileName !== '') {
      fileName = `https://marathonload.chosun.com/hof/${ele.fileName}`;
    } else {
      fileName = 'https://image.chosun.com/chuncheonmarathon/2023/honor_list_default.png';
    }

    recordCnt = ele.recordCnt;
    bestYear = ele.bestYear;
    bestRecord = ele.bestRecord;
    const listNumber = ele.no;

    renderTarget.innerHTML += `
						<div class="list_card" id="hof_${i}" onclick="honorFn.hofListDetail(${listNumber})">
								<img class="hof_img" src="${fileName}">
								<div class="hof_detail_area">
										<div class="hof_flex">
												<span class="hof_data_title mgr-ssm">이름</span>
												<span class="hof_data_detail" id="hof_name_${i}">${name}</span>
										</div>
										<div class="hof_flex">
												<span class="hof_data_title mgr-ssm">참가횟수</span>
												<span class="hof_data_detail" id="hof_cnt_${i}">${recordCnt}회</span>
										</div>
										<div class="hof_flex">
												<span class="hof_data_title mgr-ssm">최고기록(연도)</span>
												<span class="hof_data_detail" id="hof_best_${i}">${bestRecord}(${bestYear})</span>
										</div>
								</div>
						</div>
						`;
  });

  totalData = hofListObj.data.totalCnt;
}

function paging(currentPage) {
  if (Mobile()) {
    pageCount = 5;
  } else {
    pageCount = 10;
  }

  const totalPage = Math.ceil(totalData / 15); // 총 페이지 수

  if (totalPage < pageCount) {
    pageCount = totalPage;
  }

  const pageGroup = Math.ceil(currentPage / pageCount); // 페이지 그룹
  let last = pageGroup * pageCount; // 화면에 보여질 마지막 페이지 번호

  if (last > totalPage) {
    last = totalPage;
  }

  const first = last - (pageCount - 1); // 화면에 보여질 첫번째 페이지 번호
  const next = last + 1;
  const prev = first - 1;

  let pageHtml = '';

  pageHtml += "<button class='pagination-button' type='button' id='prev-button'></button>";

  // 페이징 번호 표시
  for (let i = first; i <= last; i++) {
    if (currentPage === i) {
      pageHtml
				+= `<button class='pagination-number' type='button' id='${i}'>${i}</button>`;
    } else {
      pageHtml += `<button class='pagination-number' type='button' id='${i}'>${i}</button>`;
    }
  }

  pageHtml += "<button class='pagination-button' type='button' id='next-button'></button>";

  document.getElementById('pagingul').innerHTML = pageHtml;

  if (prev > 0) {
    document.getElementById('prev-button').disabled = false;
  } else {
    document.getElementById('prev-button').disabled = true;
  }

  if (last < totalPage) {
    document.getElementById('next-button').disabled = false;
  } else {
    document.getElementById('next-button').disabled = true;
  }

  // 페이징 번호 클릭 이벤트
  document.querySelectorAll('#pagingul button').forEach((button) => {
    // eslint-disable-next-line func-names
    button.addEventListener('click', async function () {
      const id = this.id;
      let selectedPage = this.textContent;

      if (id === 'next-button') selectedPage = next;
      if (id === 'prev-button') selectedPage = prev;

      globalCurrentPage = selectedPage;

      hofListObj = await api.hofList([
        genderCheck,
        completeCnt,
        document.getElementById('hof_best').value,
        document.getElementById('hof_type').value,
        document.getElementById('hof_value').value,
        selectedPage - 1,
      ]);

      document.querySelectorAll('.list_card').forEach((el) => el.remove());

      hofIndList();

      paging(selectedPage);

      // 현재 페이지 버튼에 active 클래스 추가
      const currentBtn = document.getElementById(selectedPage);
      if (currentBtn) currentBtn.classList.add('active');
    });
  });
}

// 명예의 전당 검색
async function hofSearch() {
  genderCheck = document.getElementById('hof_gender').value || 'A';
  completeCnt = document.getElementById('hof_cnt').value || 'desc';

  hofListObj = await api.hofList([genderCheck, completeCnt, document.getElementById('hof_best').value, document.getElementById('hof_type').value, document.getElementById('hof_value').value, 0]);

  if (hofListObj.data.hofDetailDtoList.length > 0) {
    document.querySelectorAll('.list_card').forEach((el) => el.remove());
    hofIndList();
    paging(1);

    setTimeout(() => {
      const btn = document.getElementById('1');
      if (btn) btn.classList.add('active');
    }, 0);
  } else {
    alert('조회 결과가 없습니다.');

    hofListObj = await api.hofList(['A', 'desc', document.getElementById('hof_best').value, document.getElementById('hof_type').value, '', 0]);
    document.querySelectorAll('.list_card').forEach((el) => el.remove());

    hofIndList();
    paging(1);
    setTimeout(() => {
      const btn = document.getElementById('1');
      if (btn) btn.classList.add('active');
    }, 0);
  }
}

function changeMedalimg(value) {
  const medalImgElement = document.getElementById('medal_img_id');
  const medalTextElement = document.getElementById('medal_text_id');

  const medalMap = {
    2013: 'medal_2013.png',
    2014: 'medal_2014.png',
    2015: 'medal_2015.png',
    2016: 'medal_2016.png',
    2017: 'medal_2017.png',
    2018: 'medal_2018.png',
    2019: 'medal_2019.png',
    2022: 'medal_2022.png',
    2023: 'medal_2023.png',
    2024: 'medal_2024.png',
    2025: 'medal_2025.png',
  };

  let imgSrc;

  if (value > 1994 && value < 2013) {
    imgSrc = 'past_medal.png';
    if (medalTextElement) {
      medalTextElement.innerText = value;
    }
  } else if (medalMap[value]) {
    imgSrc = medalMap[value];
  }

  if (imgSrc) {
    medalImgElement.innerHTML = `<img class="medal_img" src="https://image.chosun.com/chuncheonmarathon/2023/${imgSrc}">`;
  } else {
    medalImgElement.innerHTML = ''; // 값 없을 때 처리 (선택 사항)
  }
}

// 버튼 클릭시 데이터 표출
// eslint-disable-next-line no-unused-vars
function recordDetail(id) {
  const objectData = hofIndividualObj.data.recordList[id];

  document.getElementById('medal_text_id').innerText = '';
  changeMedalimg(Number(objectData.year), objectData);

  for (let i = 0; i < hofIndividualObj.data.recordList.length; i++) {
    const el = document.getElementById(`re_${i}`);
    if (el) el.classList.remove('current');
  }

  const currentEl = document.getElementById(`re_${id}`);
  if (currentEl) currentEl.classList.add('current');

  const currentBtn = document.querySelector('.record_btn_list.current');
  const scrollContainer = document.querySelector('.record_item');

  if (currentBtn && scrollContainer) {
    const scrollLeft = currentBtn.getBoundingClientRect().left - scrollContainer.getBoundingClientRect().left;
    const curLeft = scrollContainer.scrollLeft;

    // 부드러운 스크롤
    scrollContainer.scrollTo({
      left: curLeft + scrollLeft - 150,
      behavior: 'smooth',
    });
  }

  document.getElementById('record_hof_year').innerText = `${objectData.year}년`;
  document.getElementById('record_bno').innerText = `${objectData.bno}번`;

  document.getElementById('record_netfull').innerText = timeConvert(objectData.rec);
  document.getElementById('record_nettime').innerText = timeConvert(objectData.rec);
  document.getElementById('record_guntime').innerText = timeConvert(objectData.recGun);
  document.getElementById('record_pace').innerText = objectData.recP !== '' ? objectData.recP : '-';
  document.getElementById('record_rank').innerText = objectData.levelAll;
  document.getElementById('record_agerank').innerText = objectData.levelAge !== '' ? objectData.levelAge : '-';

  document.getElementById('record_5').innerText = timeConvert(objectData.rec5km);
  document.getElementById('record_10').innerText = timeConvert(objectData.rec10km);
  document.getElementById('record_15').innerText = timeConvert(objectData.rec15km);
  document.getElementById('record_20').innerText = timeConvert(objectData.rec20km);
  document.getElementById('record_half').innerText = timeConvert(objectData.recHalf);
  document.getElementById('record_25').innerText = timeConvert(objectData.rec25km);
  document.getElementById('record_30').innerText = timeConvert(objectData.rec30km);
  document.getElementById('record_35').innerText = timeConvert(objectData.rec35km);
  document.getElementById('record_40').innerText = timeConvert(objectData.rec40km);
}

// 개인 기록 리스트 표출
function recordList() {
  const renderTarget = document.getElementById('record_ind');
  let recordYear = '';
  const courseIcon = [];
  let recordTime = '';
  let html = '';

  hofIndividualObj.data.recordList.forEach((ele, i) => {
    recordYear = ele.year;
    recordTime = ele.rec;

    const calTime = timeConvert(recordTime);

    courseIcon[0] = 'icon_full.png';
    courseIcon[1] = '풀코스';

    html += `
						<button type="button" class="record_btn_list mgr-sm-5 mg-bt-sm" id="re_${i}" value="${i}" onclick="recordDetail(this.value)">
								<div class="flex_box flex_center">
										<span class="record_btn_year mgr-ssm-2">${recordYear}년</span>
										<img src="https://image.chosun.com/chuncheonmarathon/2023/${courseIcon[0]}" alt="${courseIcon[1]}">
								</div>
								<span class="record_btn_time">${calTime}</span>
						</button>
						`;
    renderTarget.innerHTML = html;
  });
}

window.recordDetail = recordDetail;

const honorFn = {
  // 명예의 전당 개인별 기록 조회
  async hofListDetail(value) {
    hofIndividualObj = await api.hofListIndividual(value);

    if (hofIndividualObj.data.recordList.length > 0) {
      document.querySelector('.honer_check_form').style.display = 'none';
      document.querySelector('.result_ind_form').style.display = 'block';

      if (hofIndividualObj.data.fileName !== '') {
        document.getElementById('hof_title_img').innerHTML = `<img src="https://marathonload.chosun.com/hof/${hofIndividualObj.data.fileName}" alt="">`;
        document.getElementById('hof_img_expand').value = `https://marathonload.chosun.com/hof/${hofIndividualObj.data.fileName}`;
      } else {
        document.getElementById('hof_title_img').src = 'https://image.chosun.com/chuncheonmarathon/2023/honor_list_default.png';
        document.getElementById('hof_img_expand').style.display = 'none';
      }

      document.getElementById('hof_title_name').innerText = `${hofIndividualObj.data.name}(${hofIndividualObj.data.birth.substring(0, 4)})`;
      document.getElementById('hof_title_first').innerText = `${hofIndividualObj.data.firstYear}년`;
      document.getElementById('hof_title_part').innerText = `${hofIndividualObj.data.firstYear}~${hofIndividualObj.data.lastYear}년`;
      document.getElementById('hof_title_fin').innerText = `${hofIndividualObj.data.recordList.length}회`;
      document.getElementById('hof_title_record').innerText = `${hofIndividualObj.data.year}년`;

      document.getElementById('ind_name').innerText = hofIndividualObj.data.name;
      document.getElementById('ind_count').innerText = hofIndividualObj.data.recordList.length;
      document.getElementById('ind_count_mobile').innerText = hofIndividualObj.data.recordList.length;

      recordList();
      document.getElementById('re_0').click();
      document.getElementById('re_0').focus();
    }
  },

  recordPrev() {
    document.querySelector('.honer_check_form').style.display = 'block';
    document.querySelector('.result_ind_form').style.display = 'none';
  },

  // 모바일 옵션 팝업 출력
  mobileOption() {
    modal.style.display = 'block';
    document.body.classList.add('modal-open');
  },

  // 모바일 옵션 필터 적용 버튼 클릭 이벤트
  async mobileOptionFilter() {
    hofListObj = new Object();

    const gender = document.querySelector('input[name="mobile_gender"]:checked')?.value || '';
    const count = document.querySelector('input[name="count"]:checked')?.value || '';
    const best = document.querySelector('input[name="best"]:checked')?.value || '';

    hofListObj = await api.hofList([gender, count, best, 'name', '', 0]);

    if (hofListObj.data.hofDetailDtoList.length > 0) {
      document.querySelectorAll('.list_card').forEach((el) => el.remove());
      hofIndList();
      paging(1);

      setTimeout(() => {
        const btn = document.getElementById('1');
        if (btn) btn.classList.add('active');
      }, 0);
    } else {
      alert('조회 결과가 없습니다.');

      hofListObj = await api.hofList(['A', 'desc', document.getElementById('hof_best').value, document.getElementById('hof_type').value, '', 0]);
      document.querySelectorAll('.list_card').forEach((el) => el.remove());

      hofIndList();
      paging(1);
      setTimeout(() => {
        const btn = document.getElementById('1');
        if (btn) btn.classList.add('active');
      }, 0);
    }

    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
  },
};

export default honorFn;

window.honorFn = honorFn;

document.addEventListener('DOMContentLoaded', () => {
  hofSearch();
});

closeBtn.addEventListener('click', () => {
  modal.style.display = 'none';
  document.body.classList.remove('modal-open');
});

document.getElementById('hof-search').addEventListener('click', () => {
  hofSearch();
});

document.getElementById('hof_gender').addEventListener('change', () => {
  hofSearch();
});

document.getElementById('hof_cnt').addEventListener('change', () => {
  hofSearch();
});

document.getElementById('hof_best').addEventListener('change', () => {
  hofSearch();
});
